import type { Story } from '@/store/story-types'

export const COFFEE_SHOP_STORE_NEW3_STORY: Story = {
  id: 'coffee-shop-store-new3',
  name: 'BrewHaus — Craft Coffee Shop',
  narrative: 'A premium craft coffee shop with artisan beverages, pastries, and coffee beans. Customers browse the menu, add items to cart, and complete checkout.',
  goals: ['Browse craft coffee and pastry catalog', 'View product details with descriptions', 'Add items to cart and manage quantities', 'Complete checkout with order summary'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Landing page with hero banner, featured products, and navigation' },
    { id: 'pg-detail', title: 'Product Detail', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'product-detail', description: 'Product detail with image, description, price, and add-to-cart' },
    { id: 'pg-cart', title: 'Cart', order: 2, status: 'completed', elementCount: 4, linkedPageId: 'cart', description: 'Shopping cart with item list, quantities, and total' },
    { id: 'pg-checkout', title: 'Checkout', order: 3, status: 'completed', elementCount: 4, linkedPageId: 'checkout', description: 'Checkout form with shipping, payment, and order confirmation' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Coffee Products',
      description: 'Customer browses the craft coffee catalog',
      steps: [
        { type: 'given', text: 'the customer opens the coffee shop app' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'product cards with images, names, and prices are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'View Product Detail',
      description: 'Customer views details of a coffee product',
      steps: [
        { type: 'given', text: 'the customer is on the home page', linkedPageId: 'home' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail page shows full description and add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3', name: 'Add to Cart',
      description: 'Customer adds a product to the cart',
      steps: [
        { type: 'given', text: 'the customer is on a product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the item is added and cart badge updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4', name: 'Complete Checkout',
      description: 'Customer completes the purchase',
      steps: [
        { type: 'given', text: 'the customer has items in cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout and submit the order' },
        { type: 'then', text: 'order confirmation is displayed and cart is cleared', linkedPageId: 'checkout' },
      ],
    },
  ],
}
